import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/progress/index.js
// module id = 287
// module chunks = 0